import { ref } from 'vue'

const cells = ref(null)
const mapProjects = ref([])
const selectedYear = ref(null)
const selectedLocation = ref(null)
const selectedProjectId = ref(null)
const selectedClientId = ref(null)
const relatedProjects = ref(null)
const currentProject = ref(null)
const currentCellName = ref("")
const hasCalculationData = ref(false)

export function useGlobals() {
    return {cells, mapProjects, selectedYear, selectedLocation, selectedProjectId, selectedClientId, relatedProjects, currentProject, currentCellName, hasCalculationData}
}